import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs } from '@material-ui/core';
import { dateToUTC, formatMoney, handleErrorToast } from '../../../shared/Functions';
import { $TransactionCreate, BillingAccountsVService, FeeTypeEnum, TokensVService, PaymentChannel } from '../../../../services/V2/gozer';
import { CCPayment } from './cc/CCPayment';
import { ACHPayment } from './ach/ACHPayment';
import { TerminalPayment } from './cc/TerminalPayment';
import { FormController } from '../../../shared/FormController';
import { TransactionsVService } from '../../../../services/V2/longhorn';

export function PaymentModal({ setShow, billingAccountId, successCallback, failureCallback, loading, setLoading }) {
    const [step, setStep] = useState<number>(1);
    const [stepName, setStepName] = useState<string>("Continue");
    const [formData, setFormData] = useState<any>({});
    const [billingAccount, setBillingAccount] = useState<any>({});
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [paymentMethod, setPaymentMethod] = useState<string>("CC");

    useEffect(() => {
        BillingAccountsVService.billingAccountsVGetById(billingAccountId)
            .then(ba => setBillingAccount(ba))
            .catch(err => failureCallback(handleErrorToast(err)))
    }, [billingAccountId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(paymentMethod === "Other"){
            if(step === 1) {
                setFormData({
                    ...formData,
                    districtId: billingAccount.districtId,
                    billingAccountId: billingAccountId
                })
            } else if(step === 2){
                let addModel = {
                    ...formData,
                    billingAccountId: billingAccountId,
                    createdAt: (formData.createdAt === "" || formData.createdAt === null || formData.createdAt === undefined) ? null :
                        dateToUTC(new Date(new Date(new Date(formData.createdAt).setDate(1+new Date(new Date(formData.createdAt)).getDate())).setHours(0)))
                };
                TransactionsVService.transactionsVCreate(addModel)
                    .then(res => {
                        successCallback(`Approval Code: ${res?.approvalCode}.\nAmount approved: ${formatMoney(res?.amount)}.\nService Fee Charged: ${formatMoney(res?.serviceFeeAmount)}`)
                        setLoading(!loading);
                        handleCancel();
                    })
                    .catch(err => {
                        failureCallback(handleErrorToast(err))
                        setStep(1)
                    })
            }
        }
    }, [step, paymentMethod])// eslint-disable-line react-hooks/exhaustive-deps

    const handleCancel = () => {
        setShow(false)
    }

    const handleRefresh = () => {
        setLoading(!loading)
        handleCancel()
    }

    const handleAdd = () => {
        var serviceFee;
        if(paymentMethod === "ACH") {
            serviceFee = billingAccount.paymentInfo.ach
        } else if(paymentMethod === "CC") {
            serviceFee = billingAccount.paymentInfo.cc
        }
        let confirm = window.confirm(`You are about to charge ${formatMoney(formData?.paymentAmount)}${serviceFee && serviceFee.feeType !== FeeTypeEnum.NONE ?
            serviceFee.feeType === FeeTypeEnum.FLAT ? ` and service fee of ${formatMoney(serviceFee.fee)}`
            : serviceFee.feeType === FeeTypeEnum.PERCENTAGE ? ` and service fee of ${formatMoney((serviceFee.fee*.01)*formData?.paymentAmount)}` : "(An error has occured)"
            : ""} to ${paymentMethod}. Are you sure?`);

        if (confirm === true) {
            let addModel = {};
            for (var obj in formData) {
                if(formData[obj] !== "")
                    addModel[obj] = formData[obj];
            }
            if(billingAccountId){
                    TokensVService.tokensVCharge(billingAccountId, formData.paymentMethod.id, { channel: PaymentChannel.ONE_TIME_PAYMENT, amount: formData.paymentAmount })
                        .then(res => {
                            successCallback(`Approval Code: ${res?.approvalCode}.\nAmount approved: ${formatMoney(res?.amount)}.\nService Fee Charged: ${formatMoney(res?.serviceFeeAmount)}`)
                            if(formData.autopay) {
                                handleAutoPay(formData.paymentMethod.id)
                            }
                            setLoading(!loading)
                            handleCancel()
                        })
                        .catch(err => {
                            failureCallback(handleErrorToast(err))
                            setStep(1)
                        })
            }
        } else setStep(1)
    };

    const handleAutoPay = (id) => {
        if(paymentMethod === "ACH") {
            TokensVService.tokensVUpdateRecurring(billingAccountId, id, true)
                    .then(x => setLoading(!loading))
                    .catch(err => failureCallback(handleErrorToast(err)))
        } else if(paymentMethod === "CC") {
            TokensVService.tokensVUpdateRecurring(billingAccountId, id, true)
                .then(x => setLoading(!loading))
                .catch(err => failureCallback(handleErrorToast(err)))
        }
    }

    const handleChange = (e, t) => {
        setSelectedTab(t)
        if(t === 0) {
            setPaymentMethod("CC")
            setStep(1)
        } else if (t === 1) {
            setPaymentMethod("ACH")
            setStep(1)
        } else if (t === 2) {
            setPaymentMethod("Terminal")
            setStep(1)
        } else if (t === 3) {
            setPaymentMethod("Other")
            setStep(1)
        }
    }
    
    const handleNext = () => {
        setStep(step+1)
    }

    return (
        <Dialog
            open={true}
            onClose={handleCancel}
            aria-labelledby="form-dialog-title"
            maxWidth="md"
        >
            <DialogTitle id="form-dialog-title">Make Payment</DialogTitle>
            <DialogContent>
                <Tabs style={{backgroundColor:"white"}} value={selectedTab} onChange={handleChange}>
                    <Tab label={"Credit Card"}></Tab>
                    <Tab label={"Bank Draft"}></Tab>
                    <Tab label={"Terminal"}></Tab>
                    <Tab label={"Other"}></Tab>
                </Tabs>
                {paymentMethod === "CC" &&
                    <CCPayment
                        billingAccountId={billingAccountId}
                        districtId={billingAccount?.districtId}
                        step={step}
                        setStep={setStep}
                        failureCallback={failureCallback}
                        handleAdd={handleAdd}
                        formData={formData}
                        setFormData={setFormData}
                        setStepName={setStepName} />
                }
                {paymentMethod === "ACH" &&
                    <ACHPayment
                        billingAccountId={billingAccountId}
                        step={step}
                        setStep={setStep}
                        failureCallback={failureCallback}
                        handleAdd={handleAdd}
                        formData={formData}
                        setFormData={setFormData}
                        setStepName={setStepName} />
                }
                {paymentMethod === "Terminal" &&
                    <TerminalPayment
                        districtId={billingAccount.districtId}
                        billingAccountId={billingAccountId}
                        successCallback={successCallback}
                        failureCallback={failureCallback}
                        step={step}
                        setStepName={setStepName}
                        handleRefresh={handleRefresh}
                        setStep={setStep} />
                }
                {paymentMethod === "Other" &&
                    <FormController
                        keys={$TransactionCreate.properties}
                        disabledKeys={["districtId", "billingAccountId"]}
                        extraKeys={null}
                        editMode={true}
                        model={formData}
                        setModel={setFormData}
                        canReadUserRoles={false}
                        canReadMeters={false}
                        canReadServiceAddresses={false}
                        districtId={null} />
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
                {stepName !== "" &&
                    <Button
                        onClick={handleNext}
                        color="primary"
                    >
                        {stepName}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}